import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  TablePaginationElement: {
    '&__container': {
      width: '100%',
      '&--padding': {
        padding: '0 25px',
      },
    },
    '&__tabel-pagination': {
      '&__caption': {
        width: '15%',
        wordBreak: 'break-word',
      },
      '&__spacer': {
        '&--flex': {
          flex: 'none',
        },
      },
      '&--color': {
        color: `${theme.palette.white} !important`,
      },
      '&--font-size': {
        fontSize: '100%',
      },
      '&--margin': {
        '&--left': {
          marginLeft: 0,
        },
        '&--right': {
          marginRight: 0,
        },
      },
      '&--padding': {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
}));
export { useStyles };
